var App = App || {};

App.HPBPromosBand = (function ($) {
    "use strict";

    function init() {
        const PromosBand = $(".component.component-homepagebannerpromos .homepage-banner-promos.mobile");
        if (PromosBand.length) {
            PromosBand.each(function () {
                PromosCarousels(PromosBand);
            });
        }
    }

    function PromosCarousels(PromosBand) {

        const prevBtn = PromosBand.find(".visual-splide__arrow.previous");
        const nextBtn = PromosBand.find(".visual-splide__arrow.next");

        const splide = new Splide(PromosBand[0], {
            pagination: true,
            type: 'slide',
            fixedWidth: "290px",
            gap: "30px",
            perPage: 2,
            drag: true,
            snap: false,
            breakpoints: {
                650: {
                    perPage: 1,
                },
            }
        });

        prevBtn.on("click", function () {
            splide.Components.Controller.go('<');
        });

        nextBtn.on("click", function () {
            splide.Components.Controller.go('>');
        });

        splide.on('ready', function () {
            if (splide.Components.Controller.getIndex() == splide.Components.Controller.getEnd()) {
                nextBtn.addClass("disabled").attr("tabindex", "-1");
            }

            $(".homepage-banner-promos.mobile .hpb-promo-card.is-visible").attr("tabindex", "0");
            $(".homepage-banner-promos.mobile .hpb-promo-card:not(.is-visible)").attr("tabindex", "-1");
        });

        splide.mount();

        splide.on('move', function () {
            if (splide.Components.Controller.getIndex() == 0) {
                prevBtn.addClass("disabled").attr("tabindex", "-1");
            }
            else {
                prevBtn.removeClass("disabled").attr("tabindex", "0");
            }

            if (splide.Components.Controller.getIndex() == splide.Components.Controller.getEnd()) {
                nextBtn.addClass("disabled").attr("tabindex", "-1");
            }
            else {
                nextBtn.removeClass("disabled").attr("tabindex", "0");
            }
        });

        splide.on('moved', function () {
            $(".homepage-banner-promos.mobile .hpb-promo-card.is-visible").attr("tabindex", "0");
            $(".homepage-banner-promos.mobile .hpb-promo-card:not(.is-visible)").attr("tabindex", "-1");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.HPBPromosBand.init();
});